import React, { useState } from 'react';
import Spinner from '../components/UI/Spinner/Spinner';

/**
 * Higher-order component to inject `setIsLoading` and `setShowContents` functions into wrapped component.
 * Renders the component and/or a Spinner loading animation.
 * @param {React.ReactNode} WrappedComponent component to be injected
 * @returns wrapped version of `WrappedComponent`
 */
const withViewLoader = WrappedComponent => {
	const HOC = props => {
		const [isLoading, setIsLoading] = useState(true);
		const [showContents, setShowContents] = useState(true);

		const setLoadingState = isComponentLoading => {
			setIsLoading(isComponentLoading);
		};
		const setShowContentsState = showComponentContents => {
			setShowContents(showComponentContents);
		};

		const contents = (
			<WrappedComponent
				{...props}
				setLoading={setLoadingState}
				setShowContents={setShowContentsState}
			/>
		);

		return isLoading ? (
			<>
				<Spinner />
				{showContents ? contents : <div>...</div>}
			</>
		) : (
			<>{contents}</>
		);
	};
	return HOC;
};

export default withViewLoader;
